// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CCKFK","name":"styles_name__B48mB","date":"styles_date__68oli","body":"styles_body__67Yk6","reply":"styles_reply__q0xuV"};